/* eslint-disable no-underscore-dangle */

class EnvironmentRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("environment--column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /* ,reject */) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Update", (this._onUpdate = this._onUpdate.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Update", this._onUpdate);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        return new Promise((resolve /* ,reject */) => {
            this._updateEnvironment();
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS.                  */
    /*******************************************/

    _onUpdate() {
        this._updateEnvironment();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _updateEnvironment() {
        this._rootElem.innerText = this._model.getEnvironmentTitle();
    }

    /*******************************************/
    /* END PRIVATE API METHODS                 */
    /*******************************************/
}

export default EnvironmentRenderer;
